<template>
  <div>
    <Header activePage="Contact" />
    <div id="contact">
     <div id="form">
       <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSd6Ov_j3MBxaEjtCKNQXkg1JBHJxjwxVcf9YeHUsgPcJxD00g/viewform?embedded=true" width="800" height="2100" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
      </div>
     <div id="text">
       <p>
         Because of the nature of government retaliation, we are certainly
         underreporting the full breadth of the issue. While some instances of
         retaliation are widely covered by local and national news sources, others
         are swept under the radar.
       </p>
       <p>
         <b>We need your help</b> to collect additional information about government targeting of
         immigrant and human rights defenders. If you feel that you, a loved one, or a
         community member has been targeted or retaliated against for their activism on behalf
         of immigrant rights, please reach out to us at the e-mail address below and we will be
         in contact with you to gather more information. Additionally, please feel free to contact
         us with links to other campaigns that we can support on this website, or with any other
         questions.
       </p>
       <p>
         <b>
         Immigrant Rights Voices is a joint project of the NYU Immigrant Rights Clinic
         and the New Sanctuary Coalition. To reach us, please contact us at
         </b>
         <a href="mailto:immigrantrightsvoices@gmail.com">immigrantrightsvoices@gmail.com.</a>
       </p>
     </div>
    </div>
  </div>
</template>

<script>
import Header from './Header.vue';

export default {
  name: 'Contact',
  components: {
    Header,
  },
};
</script>

<style scoped>
#contact {
  position: absolute;
  top: 86px;
  bottom: 72px;
  left: 0;
  right: 0;
  text-align: left;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  margin-left: 30px;
  margin-right: 30px;
}
#form {
  grid-area: 1/ 1/ 2/ 2;
  margin-top: 30px;
}
#text {
  grid-area: 1/ 2/ 2/ 4;
  margin-left: 30px;
  margin-top: 30px;
  margin-bottom: 30px;
  line-height: 1.35;
}
#text p:first-of-type {
  margin: 0px;
}
@media screen and (max-width: 1000px){
  #contact { display: block; }
  #text { margin-left: 0px; }
}
a {
  color: black;
}
a:visited{
  color:black;
}
</style>
